import { useEffect, useState } from 'react'

import Loader from 'react-loaders'

import WordCloud from './wordcloud'
import AnimatedLetters from '../AnimatedLetters'
import './index.scss'

const Skills = () => {
  const [letterClass, setLetterClass] = useState('text-animate')

  const skillsArray = 'Skills'.split('')

  const skills = [
    'Java',
    'Spring Boot',
    'Spring AI',
    'Microservices',
    'Vue.js',
    'Nuxt.js',
    'TypeScript',
    'Angular',
    'Langchain',
    'CrewAI',
    'AI',
    'MySQL',
    'Git',
    'Docker',
  ]

  useEffect(() => {
    const timer = setTimeout(() => {
      setLetterClass('text-animate-hover')
    }, 2000)
    return () => clearTimeout(timer)
  }, [])

  return (
    <>
      <div className="container skills-page">
        <div className="text-zone">
          <h1>
            <AnimatedLetters
              letterClass={letterClass}
              strArray={skillsArray}
              idx={15}
            />
            <br />
          </h1>
          <p>
            With 11 years of experience, I have a strong foundation in Java Full Stack 
            development, specializing in Spring Boot, Angular, and Microservices 
            architecture. My expertise includes developing and maintaining RESTful 
            services, working with MySQL and Oracle databases, and implementing 
            AI-powered solutions using Spring AI, Langchain, and CrewAI.
          </p>
          <p>
            My skill set spans across Java development, frontend technologies (Angular, 
            Vue, Nuxt), AI/ML integration, microservices architecture, and DevOps tools 
            like Jenkins and GitLab. I'm committed to staying updated with the latest 
            advancements in Java ecosystem and AI technologies to deliver industry-grade 
            solutions.
          </p>
        </div>

        <div className="tagcloud-wrap">
          <WordCloud />
        </div>

        <div className="skills-grid-mobile">
          {skills.map((skill, index) => (
            <div key={index} className="skill-badge">
              {skill}
            </div>
          ))}
        </div>
      </div>

      <Loader type="pacman" />
    </>
  )
}

export default Skills
